/*
 * Request money setting screen
 *
 * @param {Function} completed Handle on request money completed
 * @param {Boolean} hasSetting Has setting or not
 * @param {Boolean} isPaypal Payment method is setting as paypal or not
 * @param {Object} data Payment Info setting
 *
 * @return {Element}
 */
<template>
  <div>
    <div class="hpanel" v-if="!hasSetting">
      <div class="panel-body">
        <div class="text-center">
          <br>
          <br><h1>[<router-link :to="{path: '/setting/payment-info'}">設定</router-link>]より</h1>
          <br><h1>[ 出金情報 ]を登録して下さい。</h1>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="isActiveBank">
        <h2 class="m-n">出金依頼</h2>
        <div class="content">
          <div class="hpanel">
            <div class="bg-color-info hpanel-heading row text-white">
              <div class="col-xs-12">
                <p class="m-b-none">内容</p>
              </div>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-4 col-sm-3 col-md-3 flexbox w-100">
                  <span>金</span>
                  <span class="pd-l-28">額 :</span>
                </div>
                <div class="col-xs-8 col-sm-9 col-md-9">
                    {{ formatAmount }}
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-xs-4 col-sm-3 col-md-3 flexbox w-100">
                  <span>出金情報 :</span>
                </div>
                <div class="col-xs-8 col-sm-9 col-md-9">
                  {{ withdrawalInfo }}
                </div>
              </div>
            </div>
          </div>
          <p class="m-b-md" v-if="isPaypal">
            ※PayPalの場合、決済手数料は受取者様のご負担となります。(ペイパル手数料は<a href="https://www.paypal.com/jp/webapps/mpp/merchant/paypal-seller-fees" target="_blank">こちら</a>)
          </p>
          <p class="m-b-md" v-else>
            ※振込金額が1万円未満の場合、振込手数料（¥300(税抜)）を除いた金額が振り込まれます。
          </p>
          <div class="flexbox justify-center">
            <button type="button" class="btn w-80 h-fix-25" @click="$router.push('/revenue')">戻る</button>
            <button id="submit" class="btn btn-warning m-l-sm m-w-120" type="button" @click="requestCompleted">出金依頼</button>
          </div>
        </div>
      </div>
      <div v-else class="hpanel">
        <div class="panel-body">
          <div class="text-center">
            <br>
            <br><h1>[<router-link :to="{path: '/setting/payment-info'}">設定</router-link>]より</h1>
            <br><h1>[ 出金情報 ]を更新して下さい。</h1>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/common/utility'
import msg from '@/common/msg'
import SaleService from '@/services/saleservice'

export default {
  data () {
    return {
      loader: null
    }
  },
  props: {
    hasSetting: {
      type: Boolean,
      default: false
    },
    isPaypal: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  computed: {
    hiddenBankAccountNumber () {
      const length = this.data.bankAccountNumber.length
      return `${Array(length - 1).join('*')}${this.data.bankAccountNumber.slice(length - 2, length)}`
    },
    withdrawalInfo () {
      if (this.isPaypal) {
        return `PayPal ${this.data.paypalAccountName}`
      }
      return `${this.data.bankName} ${this.data.bankBranchName} ${this.data.bankDepositcategory} ${this.hiddenBankAccountNumber} ${this.data.bankAccountName}`
    },
    formatAmount () {
      return `¥${Util.formatMoney(this.data.amount)}`
    },
    isActiveBank () {
      return this.data.isBankDataActive
    }
  },
  methods: {
    /*
     * Call API for request payment
     *
     * @return void
     */
    requestCompleted () {
      this.loader = this.$loading.show()
      SaleService.postRequestPayment()
        .then((response) => {
          this.$emit('completed', true)
        })
        .catch((err) => {
          if (err !== msg.updateFail) {
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          } else {
            this.$emit('completed', false)
          }
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/revenue/ReqMoneySetting.vue